import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { ShopLayout } from './components/layout/ShopLayout';
import { LivingLayout } from './components/layout/LivingLayout';
import { ScrollToTop } from './components/layout/ScrollToTop';
import { Home } from './pages/Home';
import { Collection } from './pages/Collection';
import { Product } from './pages/Product';
import { Checkout } from './pages/Checkout';
import { About } from './pages/About';
import { NotFound } from './pages/NotFound';
import { LivingHome } from './pages/living/LivingHome';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31c1iue7j1yhb">
      <CartProvider data-id="element-1" data-mp="31cjk5p91r2w3">
        <ScrollToTop data-id="element-2" data-mp="2wjgrdjc3fxgy" />
        <Routes data-id="element-3" data-mp="2wiyvintcfl9k">
          <Route path="/afrekenen" element={<Checkout data-id="element-5" data-mp="2wi5pxq64f1t0" />} data-id="element-4" data-mp="2wifgpfyzpczr" />
          <Route path="/living" element={<LivingLayout data-id="element-7" data-mp="28t4k8aooa4rf" />} data-id="element-6" data-mp="28tw44o8wqe1v">
            <Route index element={<LivingHome data-id="element-9" data-mp="23vkwmk634fmt" />} data-id="element-8" data-mp="28sbend1g9lav" />
            <Route path="collectie/:slug" element={<Collection line="living" data-id="element-11" data-mp="23t8heerpojdg" />} data-id="element-10" data-mp="23u9tmmkgrbwr" />
            <Route path="product/:slug" element={<Product data-id="element-13" data-mp="3ijfvu1ti80fo" />} data-id="element-12" data-mp="3ikhaeg9qb525" />
          </Route>
          <Route element={<ShopLayout data-id="element-15" data-mp="3ml13n8r6loj0" />} data-id="element-14" data-mp="3mlj8uuvtnd32">
            <Route path="/" element={<Home data-id="element-17" data-mp="3mjq45l4rr2xp" />} data-id="element-16" data-mp="3mk85uxa7a9d0" />
            <Route path="/collectie/:slug" element={<Collection line="beauty" data-id="element-19" data-mp="3rdapodp6e4g0" />} data-id="element-18" data-mp="3rc9du70c5dx8" />
            <Route path="/product/:slug" element={<Product data-id="element-21" data-mp="6hovayao7c0" />} data-id="element-20" data-mp="3recctgjguhe3" />
            <Route path="/over-amira" element={<About data-id="element-23" data-mp="82ovg3doih9" />} data-id="element-22" data-mp="4n5i12o8na1" />
            <Route path="*" element={<NotFound data-id="element-25" data-mp="2zlv32jnmchps" />} data-id="element-24" data-mp="2zld2xbxu5jcl" />
          </Route>
        </Routes>
      </CartProvider>
    </BrowserRouter>;
}